<template>
  <LabelComponent>{{ label }}</LabelComponent>
  <Select v-model="validSelection" :data-testid="testId || 'select-input'">
    <SelectTrigger>
      <SelectValue :placeholder="placeholder || 'Select an option'" />
    </SelectTrigger>
    <SelectContent>
      <SelectGroup>
        <SelectItem v-for="item of items" :key="item" :value="item">
          {{ item }}
        </SelectItem>
      </SelectGroup>
    </SelectContent>
  </Select>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import LabelComponent from '../ui/label/LabelComponent.vue';
import { Select } from '../ui/select';
import SelectContent from '../ui/select/SelectContent.vue';
import SelectGroup from '../ui/select/SelectGroup.vue';
import SelectItem from '../ui/select/SelectItem.vue';
import SelectTrigger from '../ui/select/SelectTrigger.vue';
import SelectValue from '../ui/select/SelectValue.vue';

const props = defineProps<{
  label: string;
  items: Array<string>;
  modelValue?: string;
  placeholder?: string;
  testId?: string;
}>();

const emit = defineEmits(['update:modelValue']);

const validSelection = ref(props.modelValue);

watch(
  () => props.modelValue,
  (val) => {
    validSelection.value = val;
  },
);

watch(validSelection, (val) => {
  emit('update:modelValue', val);
});
</script>
